<template>
  <div class="fixed-bottom bottom-main-menu-wrapper" v-if="showMenu">
    <div class="bottom-main-menu">
      <button v-if="addButtonAllMenu" class="bottom-main-menu-item" type="button" @click="$emit('openMainMenu')">
        <i class="bi bi-list"></i>
        <span>Всё меню</span>
      </button>
      <router-link v-for="item in menu" class="bottom-main-menu-item" :class="{'bottom-main-menu-item-active': $route.path === item.link}" :to="item.link">
        <i class="bi" :class="item.icon"></i>
        <span>
          {{ item.name }}
          <span v-if="item.indicator" :class="item.indicatorCssClasses">{{ item.indicator }}</span>
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import { formatTimer } from "@/helpers/format_date";
import { UserModel } from "@/models/UserModel";

export default {
  data() {
    return {
      addButtonAllMenu: false,
    }
  },
  computed: {
    ...mapGetters({
      isWorking: 'timer/isWorking'
    }),
    ...mapState({
      workTime: state => state.timer.workTime,
    }),
    workTimeFormatted() {
      return UserModel.isAuth() && UserModel.current().use_timer ? formatTimer(this.workTime) : '';
    },
    menu() {
      const menuAuth = [
        {
          link: '/',
          name: 'Смена',
          icon: 'bi-clipboard-check-fill',
          indicator: this.workTimeFormatted,
          indicatorCssClasses: {
            'badge rounded-pill': true,
            'text-bg-success': !this.isWorking,
            'text-bg-danger': this.isWorking,
          }
        },
        // {
        //   link: '/archive',
        //   name: 'История смен',
        //   icon: 'bi-calendar-date-fill'
        // },
        {
          link: '/settings',
          name: 'Настройки',
          icon: 'bi-gear-fill'
        },
        {
          link: '/logout',
          name: 'Выход',
          icon: 'bi-power'
        }
      ];
      const menuNotAuth = [
        {
          link: '/login',
          name: 'Авторизация',
          icon: 'bi-lock-fill'
        }
      ];

      return UserModel.isAuth() ? menuAuth : menuNotAuth;
    },
    showMenu() {
      return this.menu.length || this.addButtonAllMenu;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/scss/my-vars.scss";

.bottom-main-menu {
  height: 60px;
  padding: 0 15px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  max-width: $site-max-width;

  &-wrapper {
    background: #111;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.99);
    z-index: 9999 !important;
  }

  &-item {
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    transition: color 0.25s linear;
    text-decoration: none;
    font-size: 21px;
    line-height: 1;
    //font-size: 30px;

    &-active, &:hover, &:active, &:focus {
      color: rgba(255, 255, 255, 1);
    }

    span {
      line-height: 1;
      font-size: 13px;
      white-space: nowrap;
      padding-top: 5px;
      //display: none;

      .badge {
        font-size: 11px;
        padding: 2px 6px;
        color: #FFF !important;
        font-weight: normal;
      }
    }
  }
}
</style>